{
  "metadata": {
    "id": "flexoki-light",
    "name": "Flexoki",
    "description": "Портировано из темы «Flexoki» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "flexoki.json",
      "project": "kepano",
      "url": "https://github.com/kepano/flexoki",
      "upstreamFile": "packages/ui/src/theme/themes/flexoki.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 24.0,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.449,
      "paletteMaxS": 0.517,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.1,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 22.3,
      "syntaxVsTextMinDeltaE": 32.6,
      "chartsMinDeltaE": 29.7,
      "textSeparationDeltaE": 26.3,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "comment",
          "b": "operator",
          "deltaE": 0.0
        },
        {
          "a": "string",
          "b": "function",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#205EA6",
      "hover": "#1d5595",
      "active": "#1a4d88",
      "foreground": "#ffffff",
      "muted": "#205ea680",
      "emphasis": "#205EA6"
    },
    "surface": {
      "background": "#FFFCF0",
      "foreground": "#100F0F",
      "muted": "#d0cdc4",
      "mutedForeground": "#494845",
      "elevated": "#b9b7ae",
      "elevatedForeground": "#100F0F",
      "raised": "#9e9c95",
      "raisedForeground": "#100F0F",
      "overlay": "#fffcf033",
      "subtle": "#e7e4da"
    },
    "interactive": {
      "border": "#97948e",
      "borderHover": "#bcbab1",
      "borderFocus": "#205EA6",
      "selection": "#100f0f24",
      "selectionForeground": "#100F0F",
      "focus": "#205ea659",
      "focusRing": "#205ea647",
      "cursor": "#100f0f",
      "hover": "#100f0f17",
      "active": "#100f0f24"
    },
    "status": {
      "error": "#AF3029",
      "errorForeground": "#ffffff",
      "errorBackground": "#af30291a",
      "errorBorder": "#af302959",
      "warning": "#BC5215",
      "warningForeground": "#ffffff",
      "warningBackground": "#bc52151a",
      "warningBorder": "#bc521559",
      "success": "#627b0b",
      "successForeground": "#ffffff",
      "successBackground": "#627b0b1a",
      "successBorder": "#627b0b59",
      "info": "#237f77",
      "infoForeground": "#ffffff",
      "infoBackground": "#237f771a",
      "infoBorder": "#237f7759"
    },
    "pr": {
      "open": "#627b0b",
      "draft": "#575753",
      "blocked": "#BC5215",
      "merged": "#BC5215",
      "closed": "#AF3029"
    },
    "syntax": {
      "base": {
        "background": "#d0cdc4",
        "foreground": "#100F0F",
        "comment": "#575753",
        "keyword": "#485a08",
        "string": "#1a5f59",
        "number": "#5E409D",
        "function": "#1a5f59",
        "variable": "#1e5799",
        "type": "#6b5101",
        "operator": "#575753"
      },
      "tokens": {
        "commentDoc": "#575753",
        "stringEscape": "#575753",
        "keywordImport": "#485a08",
        "storageModifier": "#485a08",
        "functionCall": "#1a5f59",
        "method": "#1a5f59",
        "variableProperty": "#1a5f59",
        "variableOther": "#1e5799",
        "variableGlobal": "#5E409D",
        "variableLocal": "#575753",
        "parameter": "#1e5799",
        "constant": "#5E409D",
        "class": "#6b5101",
        "className": "#6b5101",
        "interface": "#6b5101",
        "struct": "#6b5101",
        "enum": "#6b5101",
        "typeParameter": "#6b5101",
        "namespace": "#6b5101",
        "module": "#485a08",
        "tag": "#485a08",
        "jsxTag": "#485a08",
        "tagAttribute": "#1a5f59",
        "tagAttributeValue": "#1a5f59",
        "boolean": "#5E409D",
        "decorator": "#485a08",
        "label": "#1a5f59",
        "regexp": "#1a5f59"
      }
    },
    "charts": {
      "series": [
        "#205EA6",
        "#237f77",
        "#627b0b",
        "#BC5215",
        "#9b613d"
      ]
    },
    "chat": {
      "background": "#FFFCF0",
      "userMessage": "#100F0F",
      "userMessageBackground": "#b9b7ae",
      "assistantMessage": "#100F0F",
      "assistantMessageBackground": "#d0cdc4",
      "timestamp": "#575753",
      "divider": "#97948e",
      "typing": "#575753"
    },
    "loading": {
      "spinner": "#205EA6",
      "spinnerTrack": "#d0cdc4",
      "skeleton": "#d0cdc4",
      "shimmer": "#c4c2b9"
    },
    "tools": {
      "background": "#d0cdc4",
      "border": "#97948e",
      "headerHover": "#c6c4bb",
      "icon": "#205EA6",
      "title": "#100F0F",
      "description": "#575753",
      "edit": {
        "added": "#627b0b",
        "addedBackground": "#627b0b1a",
        "removed": "#AF3029",
        "removedBackground": "#af30291a",
        "modified": "#237f77",
        "modifiedBackground": "#237f771a",
        "lineNumber": "#575753"
      }
    },
    "markdown": {
      "heading1": "#100F0F",
      "heading2": "#100F0F",
      "heading3": "#100F0F",
      "heading4": "#100F0F",
      "link": "#205EA6",
      "linkHover": "#1d5595",
      "inlineCode": "#1a5f59",
      "inlineCodeBackground": "#d0cdc4",
      "blockquote": "#575753",
      "blockquoteBorder": "#97948e",
      "listMarker": "#205ea6bf",
      "bold": "#100F0F",
      "italic": "#100f0fe6",
      "strikethrough": "#575753",
      "hr": "#97948e"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#8a393e",
        "foreground": "#ffffff",
        "contrast": 7.68
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#ad683f",
        "foreground": "#000000",
        "contrast": 4.83
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#cba65f",
        "foreground": "#000000",
        "contrast": 9.16
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#bbce65",
        "foreground": "#000000",
        "contrast": 12.13
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#718f42",
        "foreground": "#000000",
        "contrast": 5.71
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#63cc61",
        "foreground": "#000000",
        "contrast": 10.34
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#69c38b",
        "foreground": "#000000",
        "contrast": 9.78
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#438e73",
        "foreground": "#000000",
        "contrast": 5.36
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#66cdc5",
        "foreground": "#000000",
        "contrast": 11.1
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#3f798c",
        "foreground": "#ffffff",
        "contrast": 4.86
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#5e83bc",
        "foreground": "#000000",
        "contrast": 5.45
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#323786",
        "foreground": "#ffffff",
        "contrast": 10.36
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#7555c2",
        "foreground": "#ffffff",
        "contrast": 5.48
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c05bc6",
        "foreground": "#000000",
        "contrast": 5.55
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#8a3b7b",
        "foreground": "#ffffff",
        "contrast": 7.02
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c6587e",
        "foreground": "#000000",
        "contrast": 5.1
      }
    ]
  }
}
